module.exports = __webpack_public_path__ + "img/enterprisePortal.2efc59e.svg";